import React from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isNative = Capacitor.isNativePlatform();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10">
      <div className="max-w-4xl mx-auto">
        {isNative && (
          <button
            onClick={handleBack}
            className="mb-6 flex items-center gap-2 text-sm font-semibold text-gray-700 active:scale-95 transition"
          >
            <span className="text-xl leading-none">‹</span>
            {t('common.back')}
          </button>
        )}

        <h1 className="text-3xl font-bold mb-2">{t('privacy.title')}</h1>
        <p className="text-sm text-gray-500 mb-8">{t('privacy.last_update')}</p>

        <Section title={t('privacy.s1_title')}>
          <p>{t('privacy.s1_p1')}</p>
          <p className="mt-2">{t('privacy.s1_p2')}</p>
          <p className="mt-2">{t('privacy.s1_p3')}</p>
        </Section>

        <Section title={t('privacy.s2_title')}>
          <p>{t('privacy.s2_p1')}</p>

          <SubTitle>{t('privacy.s2_1_title')}</SubTitle>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s2_1_li1')}</li>
            <li>{t('privacy.s2_1_li2')}</li>
            <li>{t('privacy.s2_1_li3')}</li>
            <li>{t('privacy.s2_1_li4')}</li>
          </ul>

          <SubTitle>{t('privacy.s2_2_title')}</SubTitle>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s2_2_li1')}</li>
            <li>{t('privacy.s2_2_li2')}</li>
            <li>{t('privacy.s2_2_li3')}</li>
            <li>{t('privacy.s2_2_li4')}</li>
          </ul>

          <p className="mt-2">{t('privacy.s2_p2')}</p>
          <p className="mt-2">{t('privacy.s2_p3')}</p>

          <SubTitle>{t('privacy.s2_3_title')}</SubTitle>
          <p>{t('privacy.s2_3_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s2_3_li1')}</li>
            <li>{t('privacy.s2_3_li2')}</li>
            <li>{t('privacy.s2_3_li3')}</li>
          </ul>
        </Section>

        <Section title={t('privacy.s3_title')}>
          <p>{t('privacy.s3_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s3_li1')}</li>
            <li>{t('privacy.s3_li2')}</li>
            <li>{t('privacy.s3_li3')}</li>
            <li>{t('privacy.s3_li4')}</li>
            <li>{t('privacy.s3_li5')}</li>
          </ul>
          <p className="mt-2 font-semibold">{t('privacy.s3_no_sell')}</p>
        </Section>

        <Section title={t('privacy.s4_title')}>
          <p>{t('privacy.s4_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s4_li1')}</li>
            <li>{t('privacy.s4_li2')}</li>
            <li>{t('privacy.s4_li3')}</li>
          </ul>
        </Section>

        <Section title={t('privacy.s5_title')}>
          <p>{t('privacy.s5_p1')}</p>
          <p className="mt-2">{t('privacy.s5_p2')}</p>
        </Section>

        <Section title={t('privacy.s6_title')}>
          <p>{t('privacy.s6_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s6_li1')}</li>
            <li>{t('privacy.s6_li2')}</li>
            <li>{t('privacy.s6_li3')}</li>
          </ul>
          <p className="mt-2">{t('privacy.s6_p2')}</p>
        </Section>

        <Section title={t('privacy.s7_title')}>
          <p>{t('privacy.s7_p1')}</p>
        </Section>

        <Section title={t('privacy.s8_title')}>
          <p>{t('privacy.s8_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('privacy.s8_li1')}</li>
            <li>{t('privacy.s8_li2')}</li>
            <li>{t('privacy.s8_li3')}</li>
            <li>{t('privacy.s8_li4')}</li>
            <li>{t('privacy.s8_li5')}</li>
          </ul>
          <p className="mt-2">{t('privacy.s8_p2')}</p>
        </Section>

        <Section title={t('privacy.s9_title')}>
          <p>{t('privacy.s9_p1')}</p>
        </Section>

        <Section title={t('privacy.s10_title')}>
          <p>{t('privacy.s10_p1')}</p>
        </Section>

        <Section title={t('privacy.s11_title')}>
          <p><strong>{t('privacy.s11_responsible')}:</strong> Mikel Nieto Irureta</p>
          <p><strong>{t('privacy.s11_email')}:</strong> lontso.coach@gmail.com</p>
          <p><strong>{t('privacy.s11_country')}:</strong> España</p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold mb-3">{title}</h2>
    <div className="space-y-2 text-sm leading-relaxed">{children}</div>
  </section>
);

const SubTitle = ({ children }) => (
  <h3 className="font-semibold mt-4 mb-2">{children}</h3>
);

export default PrivacyPolicyPage;
